import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { AuthService, SalesforceService } from './../../../services';
import { withStyles } from './../../../themes/default';
import { Image } from './../../../components/includes/ui';
import { SnackbarStatic } from './../../../components/includes/snackbar';
import AuthForm from './../auth';

import CONSTANT from './../../../config/constant';

const styles = theme => ({
  root:           { maxWidth: 400 },
  brandContainer: { marginBottom: theme.spacing.unit * 5, textAlign: 'center' },
  brandImage:     { maxWidth: 210, textAlign: 'center', display: 'inline-block' },
  alertContainer: { marginBottom: theme.spacing.unit * 2 }
});

class Login extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      form: 1,
      submitAuth: false,
      errorAuthVisible: false,
      errorAuthMessage: null
    };
  }

  /*
  ** @Service
  ** @Description: Auth User
  */

  handleAuth = (values) => {

    // @State
    this.setState({ submitAuth: true });

    AuthService.login(values).then((response) => {

      if(response.status){

        // @LocalStorage
        localStorage.setItem('user', JSON.stringify(response.user));
        localStorage.setItem('token', JSON.stringify(response.token));

        // @Props
        this.props.UserSet(response);

        // @Salesforce
        this.handleAuthInSalesforce();

        setTimeout(() => {

          // @Redirect
          this.props.history.push('/dashboard');

       }, 500);

      }else{

        // @State
        this.setState({
          submitAuth: false,
          errorAuthVisible: true,
          errorAuthMessage: "Por favor chequee su usuario y contraseña."
        });

      }

    }).catch((error) => {

      // @State
      this.setState({
        submitAuth: false,
        errorAuthVisible: true,
        errorAuthMessage: "Hubo un error interno, por favor contactar a un administrador."
      });

      // @Alert
      //this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Auth in Salesforce
  */

  handleAuthInSalesforce = () => {

    SalesforceService.auth().then((response) => {

      // @LocalStorage
      // @Description: Set auth Salesforce response
      localStorage.setItem('salesforce', JSON.stringify(response));

      // @State
      this.setState({ submitAuth: false });

    }).catch((error) => {

      // @LocalStorage
      // @Description: Set auth Salesforce response
      localStorage.setItem('salesforce', JSON.stringify({ status: false, error: error.data.error, error_description: error.data.error_description }));

    });

  }

  render() {

    const { submitAuth, errorAuthVisible, errorAuthMessage } = this.state;
    const { classes } = this.props;

    return (
      <div className={ classes.root }>
        <div className={ classes.brandContainer }>
          <Image src="assets/brand/hipotecario-seguros-cyan.png" alt={ CONSTANT.site.name } className={ classes.brandImage }/>
        </div>
        { errorAuthVisible && (
          <div className={ classes.alertContainer }>
            <SnackbarStatic
              icon="info"
              variant="error"
              message={ errorAuthMessage }
              open={true}
              fullWidth hideClose/>
          </div>
        )}
        <AuthForm onSubmit={ this.handleAuth } hasSubmit={ submitAuth }/>
      </div>
    )

  }

}

const mapStateToProps = (state) => {
  return {
    User: state.User
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    UserSet: (data) => {
      dispatch({
        type: 'USER_SET',
        data: data
      });
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login)));
